export const NODE_ENV: string = process.env.NODE_ENV || "development";
export const isDevEnv = Object.is(NODE_ENV, "development");
export const isProdEnv = Object.is(NODE_ENV, "production");

export default {
  NODE_ENV,
  isDevEnv,
  isProdEnv,
};
